import {Suspense, useEffect, useState} from 'react'
import {Toaster} from 'react-hot-toast'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {getErrorToast, getSuccessToast} from './constructor/helpers/toasts'
import {AuthInit, useAuth} from './modules/auth'
import ProfileCompleteModal from './modules/auth/components/ProfileCompleteModal'

const App = () => {
    /*   useEffect(() => {
        const ws = new WebSocket("https://sockets.docacrm.com/ws")
        ws.onopen = () => console.log("successful ws connection")
      }, []) */
    const {currentUser} = useAuth()

    const [showIsProfileEditModal, setShowIsProfileEditModal] = useState(false)

    useEffect(() => {
        if (currentUser?.is_profile_modal_edit) {
            setShowIsProfileEditModal(true)
        }
    }, [currentUser])

    const handleShowIsProfileEditModal = () => {
        setShowIsProfileEditModal(!showIsProfileEditModal)
    }

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | undefined

        const onFinalized = (e: Event) => {
            const d = (e as CustomEvent).detail || {}

            if (timer) clearTimeout(timer)

            timer = setTimeout(() => {
                if (d.ok) {
                    getSuccessToast('Оплата прошла успешно')
                } else {
                    getErrorToast(
                        d.reason ||
                            'Оплата не удалась. Бронь отменена. Попробуйте еще раз или оплатите '
                    )
                }
            }, 2000)
        }

        window.addEventListener('payment-finalized', onFinalized as EventListener)

        return () => {
            window.removeEventListener('payment-finalized', onFinalized as EventListener)
            if (timer) clearTimeout(timer)
        }
    }, [])

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <I18nProvider>
                <LayoutProvider>
                    <AuthInit>
                        <ProfileCompleteModal
                            show={showIsProfileEditModal ?? false}
                            setShow={handleShowIsProfileEditModal}
                        />
                        <Outlet />
                        <MasterInit />
                        <Toaster position='bottom-right' />
                    </AuthInit>
                </LayoutProvider>
            </I18nProvider>
        </Suspense>
    )
}

export {App}
